<template>
    <div class="allPage">
<!--        <Header class="header"/>-->
        <newHeader class="header"/>
        <div class="Box scrollbar" >
            <router-view class="content"/>
            <Footer class="footer"/>
        </div>
    </div>
</template>

<script>
    import Header from "../components/header/Header";
    import newHeader from "../components/customHeader/index";
    import Footer from "../components/Footer";

    export default {
        name: "home",
        components: {
            // Header,
            newHeader,
            Footer
        },
    }
</script>

<style scoped lang="less">
    .allPage {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: auto;
        .Box {
            flex: 1;
            overflow: auto;
            /*display: flex;*/
            /*flex-direction: column;*/
            /*.content{*/
                /*flex: 1;*/
            /*}*/
        }

    }
</style>